import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AuthCallback } from "./components/AuthCallback";
import Landing from "./pages/Landing";
import Plans from "./pages/Plans";
import Search from "./pages/Search";
import Verify from "./pages/Verify";
import HostDashboard from "./pages/HostDashboard";
import Admin from "./pages/Admin";
import PaymentReturn from "./pages/PaymentReturn";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono text-sm">Connecting…</div>;
  }
  if (!user) return <Navigate to="/" replace />;
  if (role && user.role !== role && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/plans" element={<Plans />} />
      <Route path="/search" element={<Search />} />
      <Route path="/verify" element={<Protected><Verify /></Protected>} />
      <Route path="/dashboard" element={<Protected role="host"><HostDashboard /></Protected>} />
      <Route path="/admin" element={<Protected role="admin"><Admin /></Protected>} />
      <Route path="/payment/success" element={<PaymentReturn />} />
      <Route path="/payment/cancel" element={<PaymentReturn />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function ThemeInit() {
  useEffect(() => {
    const saved = localStorage.getItem("opn_theme") || "dark";
    document.documentElement.classList.toggle("dark", saved === "dark");
  }, []);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <ThemeInit />
      <BrowserRouter>
        <Router />
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
